import { createReducer } from 'pobble-components/dist/redux-helpers'

let defaultState = {
  opened: false,
  ids: []
}

const SetAgeGroupDialogReducer = createReducer(defaultState, {
  'PUPILS:DIALOG:SET_AGE_GROUP_OPEN': (state, { ids }) => ({
    ...state,
    opened: true,
    ids
  }),
  'PUPILS:DIALOG:SET_AGE_GROUP_CLOSE': state => ({ ...defaultState })
})

export default SetAgeGroupDialogReducer
